import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaypal } from "@fortawesome/free-brands-svg-icons";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/support-article.css";

const Support = () => (
	<section id="support-article">
		<h1>Donate a Program</h1>
		<p>Children of the ages 9 and older are being exposed to inappopriate materials on the internet, and can become addicted to porn. You can help!</p>
		<h2>How can I help?</h2>
		<p>You can donate a program from our <Link to="/pricing">pricing</Link> menu to a kid who suffers from porn and masturbation addiction.</p>
		<ul>
			<li>Help children get over porn/masturbation addiction.</li>
			<li>Stay in touch with the mentor regarding the children's progress.</li>
			<li>Get rewarded for your lifetime and continuous Sadaqah.</li>
		</ul>
		<section className="info">
			<h2><FontAwesomeIcon icon={faPaypal} /></h2>
			<div>
				<p>Can't donate an entire plan? You can donate any amount you please through our PayPal.Me link. <Link to="/support-us">Read more</Link>.</p>
			</div>
		</section>
		<Link to="/donate-a-program/request" className="link">Make a request</Link>
	</section>
);

const DonatePage = () => (
	<>
		<Navbar />
		<Support />	
		<Footer />	
	</>
);

export default DonatePage;